module.exports = __webpack_public_path__ + "static/img/4bg_6.dfde209.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_6.png
// module id = 708
// module chunks = 1